import React from "react"
import ContactEmailsComponent from "./ContactEmails"
import contactEmailsFactory from "./contactEmails.factory"

export { default as ContactEmailsQuery } from "./contactEmails.query"

export const ContactEmails = props => {
  const { data } = props
  const componentProps = { ...props, ...contactEmailsFactory.transform(data) }
  return <ContactEmailsComponent {...componentProps} />
}
